import { render, staticRenderFns } from "./CallerIdListCellRendererPhone.vue?vue&type=template&id=8fdd70d6&scoped=true&"
import script from "./CallerIdListCellRendererPhone.vue?vue&type=script&lang=js&"
export * from "./CallerIdListCellRendererPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdd70d6",
  null
  
)

export default component.exports